/*
 * @Author: zhenhui.duan
 * @Date: 2024-01-10 09:31:26
 * @Description: products tabs
 */

document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.tabs__caption li');
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', (event) => {
      tabs.forEach((tab) => tab.classList.remove('active'));
      tab.classList.add('active');
      const tabContent = tab
        .closest('div.tabs')
        .querySelectorAll('.tabs__content');
      tabContent.forEach((content) => content.classList.remove('active'));
      tabContent[index].classList.add('active');
    });
  });
});
